module.exports = __webpack_public_path__ + "img/img_040@2x.ba259340.png";